export const ava = {
  name: 'Ava',
  country: 'UK',
  hairColour: 'Brown',
  activity: 'Very active',
  year: 2023,
  invitedBy: 'Hamish',
  favouriteGames: ['D&D', "Baldur's Gate", 'League of Legends'],
};
export const charlie = {
  name: 'Charlie',
  country: 'UK',
  hairColour: 'Black',
  activity: 'Active',
  year: 2017,
  invitedBy: 'Unknown',
  favouriteGames: ['Geoguessr', 'Story Games', 'League of Legends'],
};
export const clom = {
  name: 'Clom',
  country: 'UK',
  hairColour: 'Brown',
  activity: 'Kinda active',
  year: 2022,
  invitedBy: 'Unknown',
  favouriteGames: ['League of Legends'],
};
export const demy = {
  name: 'Demy',
  country: 'Sweden',
  hairColour: 'Brown',
  activity: 'Active',
  year: 2025,
  invitedBy: 'Smuck',
  favouriteGames: ['Story Games'],
};
export const imogen = {
  name: 'Imogen',
  country: 'UK',
  hairColour: 'Ginger',
  activity: 'Kinda active',
  year: 2020,
  invitedBy: 'Unknown',
  favouriteGames: ['Final Fantasy'],
};
export const nic = {
  name: 'Nic',
  country: 'Denmark',
  hairColour: 'Brown',
  activity: 'Active',
  year: 2015,
  invitedBy: 'OG',
  favouriteGames: ['Rematch', 'League of Legends'],
};
export const joey = {
  name: 'Joey',
  country: 'UK',
  hairColour: 'Brown',
  activity: 'Very active',
  year: 2016,
  invitedBy: 'Jamie',
  favouriteGames: ['Overwatch', 'Blood on the Clocktower', 'Party Games'],
};
export const freddie = {
  name: 'Freddie',
  country: 'UK',
  hairColour: 'Brown',
  activity: 'Kinda active',
  year: 2016,
  invitedBy: 'Jake',
  favouriteGames: ['PUBG', 'League of Legends', 'Party Games'],
};
export const global = {
  name: 'Global',
  country: 'UK',
  hairColour: 'Black',
  activity: 'Active',
  year: 2025,
  invitedBy: 'Nils',
  favouriteGames: ['Overwatch', 'Tabletop Simulator'],
};
export const buppy = {
  name: 'Buppy',
  country: 'Romania',
  hairColour: 'Brown',
  activity: 'Inactive',
  year: 2025,
  invitedBy: 'Joey',
  favouriteGames: ['Blood on the Clocktower', 'Story Games', 'Infinity Nikki'],
};
export const jake = {
  name: 'Jake',
  country: 'UK',
  hairColour: 'Black',
  activity: 'Very active',
  year: 2015,
  invitedBy: 'OG',
  favouriteGames: ['MTG', 'League of Legends', 'Tabletop Simulator'],
};
export const xal = {
  name: 'Xal',
  country: 'UK',
  hairColour: 'Black',
  activity: 'Very active',
  year: 2024,
  invitedBy: 'Joey',
  favouriteGames: ['Monster Hunter', 'League of Legends', 'Party Games'],
};
export const jamie = {
  name: 'Jamie',
  country: 'UK',
  hairColour: 'Brown',
  activity: 'Active',
  year: 2015,
  invitedBy: 'Jake',
  favouriteGames: ['Rematch', 'TFT', 'Overwatch'],
};
export const robbe = {
  name: 'Robbe',
  country: 'Belgium',
  hairColour: 'Blonde',
  activity: 'Very active',
  year: 2025,
  invitedBy: 'Joey',
  favouriteGames: ['Overwatch', 'Party Games'],
};
export const fishes = {
  name: 'Fishes',
  country: 'UK',
  hairColour: 'Black',
  activity: 'Very active',
  year: 2022,
  invitedBy: 'George',
  favouriteGames: ['Lost Ark', 'Tekken', 'League of Legends'],
};
export const smuck = {
  name: 'Smuck',
  country: 'Sweden',
  hairColour: 'Blonde',
  activity: 'Very active',
  year: 2021,
  invitedBy: 'Liam',
  favouriteGames: ['Ark', 'Hearthstone', 'League of Legends'],
};
export const kasai = {
  name: 'Kasai',
  country: 'UK',
  hairColour: 'Blonde',
  activity: 'Active',
  year: 2017,
  invitedBy: 'Jamie',
  favouriteGames: ['PUBG', 'League of Legends', 'Terraria'],
};
export const hanne = {
  name: 'Hanne',
  country: 'Belgium',
  hairColour: 'Brown',
  activity: 'Active',
  year: 2024,
  invitedBy: 'Redd',
  favouriteGames: ['Overwatch', 'Blood on the Clocktower'],
};
export const sam = {
  name: 'Sam',
  country: 'Canada',
  hairColour: 'Brown',
  activity: 'Inactive',
  year: 2017,
  invitedBy: 'Harry',
  favouriteGames: ['Final Fantasy'],
};
export const nils = {
  name: 'Nils',
  country: 'UK',
  hairColour: 'Brown',
  activity: 'Kinda active',
  year: 2017,
  invitedBy: 'Sam',
  favouriteGames: ['Blood on the Clocktower', 'Among Us'],
};
export const blithe = {
  name: 'Blithe',
  country: 'Austria',
  hairColour: 'Brown',
  activity: 'Kinda active',
  year: 2022,
  invitedBy: 'Unknown',
  favouriteGames: ['Hunt Showdown', 'Lethal Company'],
};
export const kaddy = {
  name: 'Kaddy',
  country: 'Germany',
  hairColour: 'Brown',
  activity: 'Active',
  year: 2022,
  invitedBy: 'Smuck',
  favouriteGames: ['Blood on the Clocktower', 'Jackbox', 'D&D'],
};
